function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292c2e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.814,16.86a5.427,5.427,0,1,1-5.425,5.427A5.424,5.424,0,0,1,9.814,16.86Zm0,7.067a1.638,1.638,0,1,0-1.636-1.638A1.643,1.643,0,0,0,9.814,23.927Z",
  transform: "translate(30.586 -2.153)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.9,23.865l.888-7.219A2.658,2.658,0,0,1,4.567,14.32l1.944.108L12.548,8.99a3.159,3.159,0,0,1,2.116-.811l12.265,0A12.082,12.082,0,0,1,34.5,10.841l6.843,5.5,9.2,2.3a2.656,2.656,0,0,1,2.012,2.576v2.652a.7.7,0,0,1,.706.7v3.508a.9.9,0,0,1-.9.9H47.16c.022-.225.068-.44.068-.671a6.825,6.825,0,0,0-13.65,0,6.66,6.66,0,0,0,.069.671H19.262c.02-.225.066-.44.066-.671a6.823,6.823,0,1,0-13.647,0,6.2,6.2,0,0,0,.068.671H.9a.9.9,0,0,1-.9-.9V24.771A.894.894,0,0,1,.9,23.865Zm18.2-8.87,17.111.866-3.276-2.634a10.012,10.012,0,0,0-6.277-2.21H19.1Zm-2.842-.144V11.018H15.144a1.552,1.552,0,0,0-1.043.4l-3.493,3.144Z",
  transform: "translate(0 -8.177)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.286,16.86a5.427,5.427,0,1,1-5.425,5.427A5.424,5.424,0,0,1,26.286,16.86Zm0,7.067a1.638,1.638,0,1,0-1.638-1.638A1.64,1.64,0,0,0,26.286,23.927Z",
  transform: "translate(-13.786 -2.153)"
})));

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.259,
    height: 25.561,
    viewBox: "0 0 53.259 25.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.588a780b.svg";
export { ForwardRef as ReactComponent };